export enum Claim {
  Roles = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/roles'
}
